import { ValidatorRuleType } from "@tSurya/Common/Utilities/validate";

export const intialErrorFormState = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
    accountNumber: "",
};

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const OpenTradeValidatorConfig: ValidatorConfigType = {
    firstName: {
        required: true,
        minLength: 2,
        label: "First Name",
        requiredMsg: "FirstName Required"
    },
    lastName: {
        required: true,
        minLength: 2,
        label: "Last Name",
        requiredMsg: "LastName Required"
    },
    companyName: {
        required: true,
        minLength: 2,
        label: "Company Name",
    },
    accountNumber: {
        required: true,
        label: "Account Number",
    },
    email: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "Email Address",
    },
    phone: {
        required: true,
        maxLength: 12,
        label: "Phone Number",
        maxLengthMsg: "Please Enter Valid Phone Number",
        requiredMsg: "Enter valid phone number"
    },
};
